import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-wartungsbericht-abscheider',
  templateUrl: './form-wartungsbericht-abscheider.component.html',
  styleUrls: ['./form-wartungsbericht-abscheider.component.scss'],
})
export class FormWartungsberichtAbscheiderComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() anlagenreihe: string;

  ngOnInit() {}
}
